// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../../../../../../node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../../../../../node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `@media print {
  body * {
    visibility: hidden;
    max-width: 1048px;
  }
  #print-email-div, #print-email-div * {
    visibility: visible;
  }
  #print-email-div {
    position: absolute;
    left: 0;
    top: 0;
  }
}
`, "",{"version":3,"sources":["webpack://./src/pages/InsuredProfilePage/components/modals/ViewEmailModal/styles.css"],"names":[],"mappings":"AAAA;EACE;IACE,kBAAkB;IAClB,iBAAiB;EACnB;EACA;IACE,mBAAmB;EACrB;EACA;IACE,kBAAkB;IAClB,OAAO;IACP,MAAM;EACR;AACF","sourcesContent":["@media print {\n  body * {\n    visibility: hidden;\n    max-width: 1048px;\n  }\n  #print-email-div, #print-email-div * {\n    visibility: visible;\n  }\n  #print-email-div {\n    position: absolute;\n    left: 0;\n    top: 0;\n  }\n}\n"],"sourceRoot":""}]);
// Exports
export default ___CSS_LOADER_EXPORT___;
